import Monitoring from "@/components/Monitoring";

export default function Suivi() {
  return <Monitoring />;
}
